import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const { t } = useTranslation('home');

  const scrollToContent = () => {
    const el = document.getElementById('categories-section');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20stadium%20lights%20and%20colorful%20smoke%20effects%2C%20epic%20wide%20angle%20sports%20photography%2C%20energetic%20crowd%20silhouette%2C%20dark%20dramatic%20background%20with%20vibrant%20orange%20and%20warm%20accent%20lights%2C%20clean%20professional%20composition&width=1920&height=1080&seq=hero-bg-kaiyun&orientation=landscape"
          alt="开云体育 - 体育赛事平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
        <div className="animate-fade-in-up">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 tracking-tight leading-tight">
            {t('hero_title')}
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            {t('hero_subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/football"
              className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full transition-all duration-300 hover:bg-primary-600 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              {t('hero_cta')}
            </Link>
            <button
              onClick={scrollToContent}
              className="px-8 py-3.5 border-2 border-background-50/50 text-background-50 font-semibold text-sm rounded-full transition-all duration-300 hover:bg-background-50/10 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              {t('hero_cta_secondary')}
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-pulse-soft cursor-pointer">
        <button
          onClick={scrollToContent}
          className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-background-50/40 text-background-50/60 hover:text-background-50 hover:border-background-50/70 transition-all duration-300 cursor-pointer"
          aria-label="Scroll down"
        >
          <i className="ri-arrow-down-line text-lg"></i>
        </button>
      </div>
    </section>
  );
}